// user action constants
import { USER_TOKEN_EXPIRED } from "../types";

export const tokenExpired = () => ({
  type: USER_TOKEN_EXPIRED,
});
